module.exports = __webpack_public_path__ + "img/RFLSH.0ebb53cc.svg";